var _a;
export var SearchEngineTypeLabel;
(function (SearchEngineTypeLabel) {
    SearchEngineTypeLabel["ARTEMISCAN"] = "ARTEMISCAN";
    SearchEngineTypeLabel["INTERNET_SEARCH_2"] = "INTERNET SEARCH 2";
    SearchEngineTypeLabel["INTERNET_SEARCH"] = "INTERNET SEARCH";
    SearchEngineTypeLabel["OWN_NAME"] = "OWN RESTRICTED LIST";
    SearchEngineTypeLabel["DJ"] = "DOW JONES FEED";
    SearchEngineTypeLabel["DJ2"] = "DOW JONES API";
    SearchEngineTypeLabel["DJ3"] = "DOW JONES";
    SearchEngineTypeLabel["TR"] = "WORLD-CHECK";
})(SearchEngineTypeLabel || (SearchEngineTypeLabel = {}));
export var SearchEngineTypeValue;
(function (SearchEngineTypeValue) {
    SearchEngineTypeValue["ARTEMISCAN"] = "ArtemiScan";
    SearchEngineTypeValue["INTERNET_SEARCH"] = "Internet2";
    SearchEngineTypeValue["OWN_NAME"] = "OwnName";
    SearchEngineTypeValue["DJ"] = "DJ";
    SearchEngineTypeValue["DJ2"] = "DJ2";
    SearchEngineTypeValue["DJ3"] = "DJ3";
    SearchEngineTypeValue["TR"] = "TR";
    SearchEngineTypeValue["NLP"] = "NLP";
})(SearchEngineTypeValue || (SearchEngineTypeValue = {}));
export var SearchEngineLabel = (_a = {},
    _a[SearchEngineTypeValue.ARTEMISCAN] = 'ARTEMISCAN',
    _a[SearchEngineTypeValue.INTERNET_SEARCH] = 'INTERNET SEARCH',
    _a[SearchEngineTypeValue.OWN_NAME] = 'OWN RESTRICTED LIST',
    _a[SearchEngineTypeValue.DJ] = 'DOW JONES FEED',
    _a[SearchEngineTypeValue.DJ2] = 'DOW JONES API',
    _a[SearchEngineTypeValue.DJ3] = 'DOW JONES',
    _a[SearchEngineTypeValue.TR] = 'WORLD-CHECK',
    _a);
export var SearchType;
(function (SearchType) {
    SearchType["QUICKSCAN"] = "QUICKSCAN";
    SearchType["SCREENING"] = "SCREENING";
    SearchType["ODD"] = "ODD";
})(SearchType || (SearchType = {}));
export var ScreeningConclusions;
(function (ScreeningConclusions) {
    ScreeningConclusions["PEP"] = "PEP";
    ScreeningConclusions["SANCTION"] = "SANCTION";
    ScreeningConclusions["ADVERSE_NEWS"] = "ADVERSE_NEWS";
    ScreeningConclusions["NO_HIT"] = "NO_HIT";
})(ScreeningConclusions || (ScreeningConclusions = {}));
var RecordScreeningError = /** @class */ (function () {
    function RecordScreeningError() {
    }
    return RecordScreeningError;
}());
export { RecordScreeningError };
